import React from "react";
import MessageList from "../MessageList";
import ChatInput from "../ChatInput";
import { Message } from "../Message";
import "./ChatContent.scss";

interface ChatContentProps {
  messages: Message[];
  onSendMessage: (message: string) => void;
  isLoadingHistory?: boolean;
}

const ChatContent: React.FC<ChatContentProps> = ({
  messages,
  onSendMessage,
  isLoadingHistory = false,
}) => {
  const isLoading = messages.some((msg) => msg.id.startsWith("loading-"));
  
  return (
    <div className="chat-content">
      <MessageList messages={messages} isLoadingHistory={isLoadingHistory} />
      <ChatInput onSendMessage={onSendMessage} isLoading={isLoading} />
    </div>
  );
};

export default ChatContent;

